import type { ColumnsType } from 'antd/es/table';

import type { TComparisonRow, TComparisonTable, TComparisonValue } from '@/models/chat.model';

import { StyledComparisonTableLink } from '../components/ComparisonTable/ComparisonTableStyles';
import { formatComparisonValue } from './formatComparisonValue';

export type TComparisonRowRecord = {
  key: string;
  rowKey: TComparisonRow['key'];
  label: string;
} & Record<string, TComparisonValue>;

export const getComparisonTableColumns = (
  data: TComparisonTable,
  primaryColor?: string,
): ColumnsType<TComparisonRowRecord> => [
  {
    dataIndex: 'label',
    key: 'label',
    fixed: 'left' as const,
  },
  ...data.items.map((item) => ({
    title: item.url ? (
      <StyledComparisonTableLink $primary={primaryColor} href={item.url} target="_blank" rel="noopener noreferrer" title={item.title}>
        {item.id}
      </StyledComparisonTableLink>
    ) : (
      item.id
    ),
    dataIndex: item.id,
    key: item.id,
    render: (value: TComparisonValue, record: TComparisonRowRecord) =>
      formatComparisonValue(record.rowKey, value),
  })),
];
